<template>
  <div class="image-viewer-overlay" @click="close" tabindex="0" ref="viewer" @keydown.esc="close">
    <button class="nav-btn prev-btn" @click.stop="$emit('prev')" aria-label="Previous image">
      &#10094;
    </button>


    <div class="image-viewer-content" @click.stop>
      <button class="close-btn" @click="close" aria-label="Close image viewer">
        &times;
      </button>
      <img :src="imageUrl" alt="Full size image view" class="full-image" />
    </div>

    <button class="nav-btn next-btn" @click.stop="$emit('next')" aria-label="Next image">
      &#10095;
    </button>
  </div>
</template>

<script>
export default {
  name: 'ImageViewer',
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    orderedTree: {
      type: Array,
      required: false,
      default: () => []
    },
    orderedInstances: {
      type: Array,
      required: false,
      default: () => []
    },
    currentViewerITreeID: {
      type: String,
      required: false,
      default: null
    }
  },
  computed: {
  },
  mounted() {
    this.$refs.viewer.focus();
    // Also listen on window as a fallback in case focus is lost
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    handleKeydown(e) {
      if (e.key === 'Escape') {
        this.close();
      } else if (e.key === 'ArrowLeft') {
        this.$emit('prev');
      } else if (e.key === 'ArrowRight') {
        this.$emit('next');
      }
    }
  }
}
</script>

<style scoped>
.image-viewer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.85);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  outline: none;
}

.image-viewer-content {
  position: relative;
  max-width: 95vw;
  max-height: 95vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.full-image {
  max-width: 100%;
  max-height: 95vh;
  object-fit: contain;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.5);
}

.close-btn {
  position: absolute;
  top: 10px;
  left: 10px;
  background: none;
  border: none;
  color: white;
  font-size: 36px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.7;
  transition: opacity 0.2s;
  z-index: 10001;
}

.close-btn:hover {
  opacity: 1.0;
}


.nav-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.5);
  border: none;
  color: white;
  font-size: 36px;
  cursor: pointer;
  padding: 10px 15px;
  border-radius: 4px;
  opacity: 0.3;
  transition: opacity 0.2s, background 0.2s;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.nav-btn:hover {
  opacity: 0.3;
  background: rgba(0, 0, 0, 0.8);
}

.prev-btn {
  left: 10px;
}

.next-btn {
  right: 10px;
}

@media (min-width: 768px) {
  .close-btn {
    top: 15px;
    left: 15px;
  }
  .prev-btn {
    left: 20px;
  }
  .next-btn {
    right: 20px;
  }
}
</style>
